import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Detail_1({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);

  return (
    <Row className={"mb-3 mx-0"}>
      <div>
        <Row className={"_detail-section-sub-scope-name-header-pdf"}>{isSub && item.scopeName}</Row>
        <Row
          xs={isSub ? "auto" : 12}
          className={
            "  " + (isSub ? "detail-section-sub-scope-name-header-wrap-up" : "detail-section-scope-name-header-wrap-up")
          }
        >
          <Col className={"align-content-center text-end  ps-0"}>{item.name}</Col>
          <Col className={"ps-0 d-flex justify-content-start align-content-center"}>
            <div
              className={
                " " + (isSub ? "detail-sub-scope-score-header-wrap-up" : "detail-main-scope-score-header-wrap-up")
              }
              style={{
                marginRight: "auto",
                backgroundColor: colors.primary,
                color: "#ffffff",
                border: `2px solid ${colors.dark}`,
              }}
            >
              {elementScore}
            </div>
          </Col>
        </Row>

        <div className={isSub ? "detail-sub-scope-container-wrap-up" : "detail-scope-container-wrap-up"}>
          <Row>
            {item.scale.ranges.map((range, i) => {
              let isHit = range.isHit;
              return (
                <Col
                  key={i}
                  className={
                    isHit
                      ? "scale-style-wrap-up" // Remove hit classes to avoid conflicts
                      : "scale-style-wrap-up"
                  }
                  style={
                    isHit
                      ? {
                          backgroundColor: colors.light,
                          borderColor: colors.primary,
                          border: `2px solid ${colors.primary}`,
                          color: colors.dark,
                          fontWeight: "bold",
                        }
                      : {}
                  }
                >
                  {item.scale.isHtml ? (
                    <div dangerouslySetInnerHTML={{ __html: item.monoSpaceHtml }} />
                  ) : (
                    range.start + range.text + range.end
                  )}
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col xs="5">
              <div className="detail-scale-text-wrap-up" dangerouslySetInnerHTML={{ __html: item.lowSideText }} />
            </Col>
            <Col xs={{ offset: 2, span: 5 }}>
              <div className="detail-scale-text-wrap-up" dangerouslySetInnerHTML={{ __html: item.highSideText }} />
            </Col>
          </Row>
          {item.generalInformationText?.length > 2 && (
            <div
              className="detail-scale-general-info-text-wrap-up"
              dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
            />
          )}
        </div>
      </div>
    </Row>
  );
}
